/* eslint-disable dot-notation */
import { createSlice } from '@reduxjs/toolkit';

/**
 * Redux slice for customer/user authentication state
 * Manages user profile, auth status, and logout/delete account dialogs
 */
const CustomerSlice = createSlice({
  name: 'customer',
  initialState: {
    customer: null,
    status: 'idle',
    error: null,
    refreshing: false,
    show_logout_alert: false,
    show_permission_alert: false,
    show_delete_account_alert: false,
  },
  reducers: {
    /** Enables pull-to-refresh control */
    enableRefreshControl(state, action) {
      if (!action.payload?.retry) {
        state.refreshing = true;
      }
    },
    /** Disables pull-to-refresh control */
    disableRefreshControl(state) {
      state.refreshing = false;
    },
    /** Sets customer profile data */
    setCustomer(state, action) {
      state.customer = action.payload;
    },
    /** Clears customer data on logout */
    logout(state) {
      return CustomerSlice.getInitialState();
    },
    /** Shows logout confirmation dialog */
    showLogoutAlert(state) {
      state.show_logout_alert = true;
    },
    /** Hides logout confirmation dialog */
    hideLogoutAlert(state) {
      state.show_logout_alert = false;
    },
    /** Shows delete account confirmation dialog */
    showDeleteAccountAlert(state) {
      state.show_delete_account_alert = true;
    },
    /** Hides delete account confirmation dialog */
    hideDeleteAccountAlert(state) {
      state.show_delete_account_alert = false;
    },
    /** Updates specific customer property */
    updateCustomer(state, action) {
      if (state.customer) {
        state.customer = {
          ...state.customer,
          [action.payload?.key]: action.payload?.value,
        };
      }
    },
  },
});

export const {
  setCustomer,
  logout,
  showLogoutAlert,
  hideLogoutAlert,
  updateCustomer,
  enableRefreshControl,
  disableRefreshControl,
  hideDeleteAccountAlert,
  showDeleteAccountAlert,
} = CustomerSlice.actions;
export default CustomerSlice.reducer;
